import { validationTranslationKeys } from '@va/constants';
import { object, string } from 'yup';

export function getBusinessInfoSchema(translate: Function) {
  const requiredText = translate(validationTranslationKeys.required);

  return object().shape({
    firstName: string().required(requiredText),
    lastName: string().required(requiredText),
    companyName: string().required(requiredText),
    country: string().required(requiredText),
    vat: string(),
    companyWebsite: string(),
    state: string(),
    city: string(),
    zipcode: string(),
    street: string(),
  });
}
